//fontawesome library where icons can be imported and stored
//icons imported can be used anywhere in the project just by importing this library

// import the library
import { library } from "@fortawesome/fontawesome-svg-core";

// import icons
import {
  faEye,
  faPenToSquare,
  faTrashCan,
  faTrashCanUndo,
  faFolderTree,
  faFiles,
  faImages,
  faFilms,
  faArrowRight,
  faArrowRightFromBracket,
  faAngleDown,
  faUserGroup,
  faPhotoFilm,
  faRightToBracket,
  faUserShield,
  faFile,
  faFileCheck,
  faFileLines,
  faFileSignature,
  faBoxArchive,
  faTrashCanClock,
  faFolderMinus,
  faBell,
  faBellOn,
  faXmark,
  faFaceSadSweat,
  faTruckClock,
  faBuildingLock,
  faUserRobotXmarks,
  faLocationXmark,
  faCaretRight,
  faUpload,
  faCircleUser,
  faMagnifyingGlass,
  faAngleLeft,
  faPlus,
  faLayerGroup,
  faDownload,
  faFilePdf,
  faAngleRight,
  faBookmark,
  faFolder,
  faCalendar,
  faCodeCompare,
  faFileCircleExclamation,
  faListTree,
  faTimeline,
  faHeart,
  faAnglesRight,
  faAnglesLeft,
  faTags,
  faCalendarLinesPen,
  faMessageLines,
  faCircle,
  faGear,
  faEnvelope,
  faMessages,
  faBars,
  faLightbulb,
  faGhost,
  faWandMagicSparkles,
  faPallet,
  faGrid,
  faNewspaper,
  faDiagramNested,
  faLifeRing,
  faChairOffice,
  faAddressCard,
  faBoxOpenFull,
  faMicrochipAi,
  faFingerprint,
  faBroom,
  faDiagramSubtask,
  faChartLine,
  faUsers,
  faDoorOpen,
  faHouse,
  faChartScatterBubble,
  faPhotoFilmMusic,
  faFileImage,
  faFileVideo,
  faFileAudio,
  faPhoneOffice,
  faAddressBook,
  faChartDiagram,
  faBook,
  faSoap,
  faBrowser,
  faUserKey,
  faLightEmergencyOn,
  faHighlighterLine,
  faBoxMagnifyingGlass,
  faTelescope,
  // faLinkBroken,
  faBuildings,
  faBuilding,
  faSliders,
  faLinkSlash,
  faUserClock,
} from "@fortawesome/pro-regular-svg-icons";

import {
  faBookmark as solidFaBookmark,
  faPlus as solidFaPlus,
  faMinus,
  faCheck,
  faCircle as solidFaCircle,
  faStar,
} from "@fortawesome/pro-solid-svg-icons";

library.add(
  faEye,
  faPenToSquare,
  faTrashCan,
  faUpload,
  faTrashCanUndo,
  faFolderTree,
  faFiles,
  faImages,
  faFilms,
  faArrowRightFromBracket,
  faArrowRight,
  faAngleDown,
  faUsers,
  faUserGroup,
  faPhotoFilm,
  faRightToBracket,
  faUserShield,
  faFile,
  faFileCheck,
  faFileLines,
  faFileSignature,
  faBoxArchive,
  faTrashCanClock,
  faFolderMinus,
  faBell,
  faBellOn,
  faXmark,
  faFaceSadSweat,
  faTruckClock,
  faBuildingLock,
  faUserRobotXmarks,
  faLocationXmark,
  faCaretRight,
  faCircleUser,
  faMagnifyingGlass,
  faAngleLeft,
  faPlus,
  solidFaPlus,
  faMinus,
  faLayerGroup,
  faDownload,
  faFilePdf,
  faAngleRight,
  faBookmark,
  solidFaBookmark,
  faFolder,
  faCalendar,
  faCodeCompare,
  faFileCircleExclamation,
  faListTree,
  faTimeline,
  faHeart,
  faAnglesRight,
  faAnglesLeft,
  faTags,
  faCalendarLinesPen,
  faMessageLines,
  faCircle,
  faCheck,
  solidFaCircle,
  faStar,
  faGear,
  faEnvelope,
  faMessages,
  faBars,
  faLightbulb,
  faGhost,
  faWandMagicSparkles,
  faPallet,
  faGrid,
  faNewspaper,
  faDiagramNested,
  faLifeRing,
  faChairOffice,
  faAddressCard,
  faBoxOpenFull,
  faMicrochipAi,
  faFingerprint,
  faBroom,
  faDiagramSubtask,
  faChartLine,
  faDoorOpen,
  faHouse,
  faChartScatterBubble,
  faPhotoFilmMusic, 
  faListTree,
  faTags,
  faFileImage,
  faFileVideo,
  faFileAudio,
  faPhoneOffice,
  faAddressBook,
  faBookmark, 
  faChartDiagram,
  faBook,
  faSoap,
  faBrowser,
  faUserKey,
  faLightEmergencyOn,
  faHighlighterLine,
  faBoxMagnifyingGlass,
  faTelescope,
  // faLinkBroken,
  faBuildings,
  faBuilding,
  faSliders,
  faLinkSlash,
  faUserClock,
);
